import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const generateESOAConfirmation = (
  isLoading,
  transactionStatus,
  currentStatus,
  applicationStatus,
  hasGeneratedESOA,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed = ['ASSESSED BY BPLO'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['ASSESSED BY BPLO'].indexOf(applicationStatus) > -1;
  const isAllowedGenerate = isApplicationStatusAllowed && isStatusAllowed;
  const isAllowedRegenerate =
    ['EXPIRED REFERENCE NUMBER'].indexOf(transactionStatus) > -1 &&
    ['EXPIRED SOA'].indexOf(currentStatus) > -1;

  const showComponent =
    (isAllowedGenerate && !hasGeneratedESOA) || isAllowedRegenerate;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want generate eSOA for this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <div className="mx-2 mb-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Generate eSOA
      </button>
    </div>
  ) : null;

  return {
    isAllowedGenerate,
    isAllowedRegenerate,
    onHandleClick,
    component,
  };
};

export default generateESOAConfirmation;
